import { TestimonialProps } from "./types";
import * as Styled from "./styles";

const Testimonial: React.FC<TestimonialProps> = ({ quote }) => (
  <Styled.Wrapper>
    <Styled.Text as="blockquote">{quote}</Styled.Text>
  </Styled.Wrapper>
);

export default Testimonial;
